import {APIClient} from "./httpClient";

import * as url from "./endpoints";


const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
    const user = localStorage.getItem("user");
    if (user) return JSON.parse(user);
    return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
    return getLoggedInUser() !== null;
};

export const getInvoiceFile = (accessKey: string, extension: string) =>
    api.get(`${url.GET_INVOICE_FILE}/${accessKey}/${extension}`);

export const validatePassword = (password: string) =>
    api.create(url.VALIDATE_PASSWORD, { password });

export const refreshToken= () : Promise<any>  =>
  api.create(url.REFRESH_TOKEN, { });

